import { ChartBarIcon, MagnifyingGlassIcon, StarIcon, BriefcaseIcon, ChatBubbleOvalLeftEllipsisIcon, LockClosedIcon, UserGroupIcon } from '@heroicons/react/20/solid';
import parentIMG from '../assets/parent1.png'

const parentFeatures = [
  {
    name: 'Child’s Progress Dashboard',
    description: 'Real-time data and insights on your child’s academic trajectory.',
    icon: ChartBarIcon,
  },
  {
    name: 'Performance Comparison',
    description: 'See how your child’s progress compares to peers their age.',
    icon: UserGroupIcon,  
  },
  {
    name: 'Adaptive Learning',
    description: 'Witness how the platform adjusts worksheet difficulty based on your child’s performance.',
    icon: MagnifyingGlassIcon,
  },
  {
    name: 'Engagement Tools',
    description: 'Gamified elements that keep your child motivated and excited in their learning process.',
    icon: StarIcon,
  },
  {
    name: 'Printable HW Worksheets',
    description: 'Access to printable resources that cater to diverse learning styles.',
    icon: BriefcaseIcon,
  },
  {
    name: 'Feedback Mechanism',
    description: 'Provide feedback on worksheet difficulty and relevance.',
    icon: ChatBubbleOvalLeftEllipsisIcon,
  },
  {
    name: 'Data Security',
    description: 'Assured encryption for user data and compliance with GDPR.',
    icon: LockClosedIcon,
  }
];


export default function ForParents() {
  return (
    <div className="overflow-hidden py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-spring-leaves-600">Key Features for Parents</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-spring-leaves-900 sm:text-4xl">For Parents</p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-spring-leaves-600 lg:max-w-none">
                {parentFeatures.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-spring-leaves-900">
                      <feature.icon className="absolute left-1 top-1 h-5 w-5 text-spring-leaves-600" aria-hidden="true" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src={parentIMG}
            alt="Parents collaborating with educators"
            className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-spring-leaves-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
      <div className="mt-20 flex items-center justify-center gap-x-6">
          <a
            href="/news-letter"
            className="rounded-md bg-spring-leaves-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-spring-leaves-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-spring-leaves-600"
          >
            Join Wait List!
          </a>
          <a href="/faq" className="text-sm font-semibold leading-6 text-spring-leaves-800">
            Learn more <span aria-hidden="true">→</span>
          </a>
        </div>
    </div>
  )
}
